import store from './store';
import { i18n } from '../i18n';
import { getDefaultConfig, DialogOptions } from './business';
import Index from '../index.vue';
import { loadComponent } from '@tencent/wphk-components-common/utils/load-component';

const cacheKey = Symbol('dialog');

// @ts-ignore
function update(config: DialogOptions) {
  Object.keys(config).forEach((key) => {
    if (typeof store.dialog[key] !== 'undefined') {
      store.dialog[key] = config[key];
    }
  });
}

export function showDialog(options: DialogOptions) {
  loadComponent(Index, cacheKey);
  const config = Object.assign(getDefaultConfig(), {
    show: true,
  }, options);
  update(config);
}

export function hideDialog() {
  const config = Object.assign(getDefaultConfig(), {
    show: false,
  });
  update(config);
}

export function showBusinessError(error?: any, options: DialogOptions = {}) {
  if (error) {
    if (typeof error === 'string') {
      showDialog(Object.assign({}, {
        title: error,
      }, options));
      return;
    }
    const { title, retmsg, message, errMsg } = error;
    showDialog(Object.assign({}, {
      title: title || retmsg || message || errMsg || error.err_msg || i18n('系统繁忙'),
    }, options));
    return;
  }

  showDialog(Object.assign({}, {
    title: i18n('系统繁忙'),
  }, options));
}

export function showSimpleDialog(content: string) {
  loadComponent(Index, cacheKey);
  const config = Object.assign(getDefaultConfig(), {
    show: true,
  });
  config.content = content;
  console.log(config);
  update(config);
}
